export default "__VITE_ASSET__48fc8d5c__"